var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g2, _g3, _g4, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _g5, _g6, _g7, _path73, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBotsDialog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 458,
    height: 265,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M182.018 193.473c-4.807 7.739-14.966 10.125-22.705 5.318-7.739-4.807-10.126-14.967-5.319-22.705 4.807-7.739 19.262-17.047 27.001-12.24 7.739 4.807 5.83 21.922 1.023 29.661v-.034Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#20244D",
    d: "M180.041 193.198c.341 1.159.477 2.114.58 3.205.068 1.057 0 2.148-.171 3.205-.307 2.181-1.261 4.329-2.591 6.17l-.068.103a2.992 2.992 0 0 1-4.159.681 2.991 2.991 0 0 1-.682-4.159c.136-.204.307-.375.477-.511a9.117 9.117 0 0 0 2.523-3.409c.307-.682.511-1.432.648-2.216.136-.751.17-1.637.17-2.251v-.272c0-.921.682-1.705 1.603-1.705.784 0 1.431.477 1.636 1.193l.034-.034ZM165.792 197.836c-1.023 1.67-1.944 3.648-2.523 5.523-.614 1.875-.886 3.818-.716 5.454a2.984 2.984 0 0 1-2.659 3.273 2.983 2.983 0 0 1-3.273-2.659v-.716c.307-2.761 1.261-5.114 2.386-7.228a31.37 31.37 0 0 1 4.16-5.761c.613-.682 1.704-.716 2.386-.102.614.545.716 1.431.307 2.113l-.068.103ZM159.075 192.654c-.511.614-1.125 1.534-1.602 2.352-.512.853-.921 1.773-1.33 2.694a31.589 31.589 0 0 0-1.773 5.795c-.341 1.603-1.909 2.659-3.511 2.319-1.603-.341-2.66-1.91-2.319-3.512.034-.205.103-.375.171-.545v-.069c.954-2.182 2.045-4.261 3.375-6.204.682-.989 1.364-1.91 2.148-2.796.818-.921 1.568-1.705 2.659-2.557.716-.58 1.773-.443 2.352.273.512.613.478 1.5 0 2.113l-.136.171-.034-.034ZM154.779 187.1c-1.637 2.318-3.205 4.943-3.955 7.364-.409 1.364-1.875 2.148-3.239 1.739-1.363-.409-2.147-1.875-1.738-3.239.068-.205.17-.409.272-.614 1.875-3.068 4.091-5.148 6.512-7.261a1.422 1.422 0 0 1 2.046.136c.443.511.477 1.261.102 1.807l-.068.068h.068Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "M157.719 203.299a2.83 2.83 0 1 0 5.283 2.028l.721-1.878a2.83 2.83 0 0 0-5.283-2.028l-.721 1.878ZM174.994 199.729a2.829 2.829 0 0 0 5.284 2.028l.72-1.878a2.83 2.83 0 1 0-5.283-2.028l-.721 1.878ZM151.243 195.759a2.83 2.83 0 0 0 4.808 2.986l1.061-1.709a2.83 2.83 0 1 0-4.807-2.986l-1.062 1.709ZM147.556 189.4a2.829 2.829 0 1 0 4.808 2.985l1.061-1.709a2.83 2.83 0 0 0-4.808-2.985l-1.061 1.709Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M267.93 158.05c-.819-3.41-17.558-6.171-38.082-6.171-20.523 0-37.331 2.727-38.081 6.171-2.045 9.102-3.136 17.148-3.136 22.603 0 22.024 18.444 39.888 41.217 39.888 22.774 0 41.218-17.864 41.218-39.888 0-5.455-1.091-13.501-3.136-22.603Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "M229.85 164.698c21.07 0 38.15-2.87 38.15-6.41s-17.08-6.409-38.15-6.409c-21.069 0-38.149 2.869-38.149 6.409 0 3.54 17.08 6.41 38.149 6.41Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#20244D",
    d: "M236.087 198.928c-.955.034-1.909.068-2.864.068v-5.523c0-1.159-.068-1.909-.17-2.25-.137-.341-.307-.614-.614-.784-.273-.205-.614-.273-.989-.273-.511 0-.954.137-1.329.409-.409.273-.682.614-.818 1.091-.137.444-.205 1.262-.205 2.489v4.909c-.955 0-1.909-.034-2.864-.068v-10.841c.887 0 1.773.068 2.659.068v1.602c.955-1.193 2.148-1.807 3.58-1.841.648 0 1.227.103 1.739.307.511.205.92.478 1.193.853.273.34.443.75.546 1.193.102.443.17 1.091.17 1.909v6.716l-.034-.034ZM236.805 193.098c0-.955.238-1.875.716-2.796.477-.92 1.125-1.636 2.011-2.147.852-.512 1.807-.819 2.898-.921 1.636-.136 2.966.239 4.023 1.193 1.057.955 1.568 2.216 1.568 3.853 0 1.636-.511 3.068-1.568 4.261-1.057 1.194-2.387 1.875-3.989 2.012-.989.068-1.943-.068-2.83-.477a4.061 4.061 0 0 1-2.045-1.876c-.478-.852-.716-1.875-.716-3.136m2.932 0c0 1.091.238 1.875.75 2.421.511.545 1.125.784 1.875.715.75-.068 1.364-.409 1.875-1.022.511-.614.75-1.466.75-2.557 0-1.057-.239-1.841-.75-2.387-.511-.511-1.125-.75-1.875-.682-.75.069-1.364.41-1.875.989-.512.614-.75 1.432-.75 2.523ZM222.077 185.018v7.023c0 1.193-.034 2.012-.137 2.523-.102.511-.34.921-.784 1.227-.443.307-1.091.444-1.943.375-.852-.068-1.5-.306-1.977-.75a2.845 2.845 0 0 1-.921-1.568c-.068-.375-.102-1.227-.102-2.523v-6.852a93.054 93.054 0 0 1-3-.375c-.58.511-.921.784-1.5 1.295v1.125c.511.068.988.137 1.5.205v4.057c0 1.67.102 2.966.307 3.818.136.58.409 1.193.852 1.773a5.778 5.778 0 0 0 1.739 1.5c.75.409 1.807.682 3.238.818 1.194.102 2.148 0 2.864-.238.75-.239 1.33-.614 1.773-1.126.443-.477.75-1.09.921-1.84.17-.751.238-2.012.238-3.785v-6.58c-1.023-.034-2.011-.102-3.034-.17l-.034.068ZM249.283 195.996c-.512.068-.955.546-.955 1.057 0 .512.409.887.955.818.545-.068.954-.545.954-1.056 0-.512-.409-.887-.92-.819m0 1.671c-.409.068-.716-.239-.716-.648 0-.409.307-.784.716-.818.409-.068.716.238.716.648 0 .409-.307.784-.716.818Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#20244D",
    d: "M249.657 197.124s-.068-.171-.17-.205c.102-.034.204-.136.204-.238 0-.103-.034-.171-.102-.205-.068 0-.136-.034-.307 0a.859.859 0 0 0-.341.068v.921h.205v-.375h.102c.102 0 .171 0 .205.136 0 .102.034.171.068.205h.239s-.035-.103-.069-.239m-.409-.239h-.102v-.272h.102c.137 0 .205 0 .205.102s-.102.136-.205.17Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "m150.858 107.047-1.159 1.125-5.864-2.284c-.818-.307-1.364-1.262-1.33-2.353l.239-12.853c0-1.09.613-2.011 1.432-2.284l5.898-2.011 1.091 1.159c-1.807 6.341-1.875 12.819-.341 19.467l.034.034Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m163.779 119.596-15.853-6.205c-1.057-.409-1.875-1.398-2.25-2.625-.239-.819-.239-1.739-.035-2.591a60.704 60.704 0 0 0 .273-22.876c.034-1.978 1.125-3.716 2.659-4.228l16.092-5.352-.852 43.843-.034.034Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M154.607 119.322h-4.091c-1.091-.034-1.944-.989-1.91-2.114l1.534-74.219 1.228-1.227h5.625c.443.545.716.818 1.159 1.33l-1.534 74.218c0 1.125-.92 2.046-1.977 2.012h-.034Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "m307.58 107.051 1.159 1.125 5.864-2.285c.818-.306 1.364-1.261 1.33-2.352l-.239-12.853c0-1.09-.614-2.011-1.432-2.284l-5.898-2.011-1.091 1.159c1.807 6.34 1.875 12.818.341 19.467l-.034.034Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "m294.66 119.596 15.853-6.205c1.057-.409 1.875-1.398 2.25-2.625.238-.819.238-1.739.034-2.591a60.725 60.725 0 0 1-.273-22.876c-.034-1.978-1.125-3.716-2.659-4.228l-16.092-5.352.853 43.843.034.034Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M303.831 119.322h4.091c1.091-.034 1.943-.989 1.909-2.114l-1.534-74.219-1.228-1.227h-5.625c-.443.545-.716.818-1.159 1.33l1.534 74.218c0 1.125.921 2.046 1.978 2.012h.034Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M296.399 73.126c-12.342-27.308-37.945-41.524-67.537-41.524-29.592 0-55.162 14.25-67.537 41.524a18.589 18.589 0 0 0-1.364 10.875c1.33 7.569 1.568 26.047.614 32.797-.648 4.569.307 9.239 2.863 12.921 13.024 18.853 37.434 26.354 65.424 26.354 27.99 0 52.4-7.501 65.423-26.354 2.523-3.682 3.511-8.352 2.864-12.921-.955-6.75-.716-25.228.613-32.797a18.829 18.829 0 0 0-1.363-10.875Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E7",
    d: "M160.573 116.797c-.648 4.568.307 9.239 2.864 12.921 13.023 18.853 37.433 26.353 65.423 26.353 27.99 0 52.4-7.5 65.424-26.353 2.522-3.682 3.511-8.353 2.863-12.921-22.057 28.16-106.368 37.842-136.574 0Z",
    opacity: 0.54,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#20244D",
    d: "M276.283 120.922c-29.081 11.83-67.094 12.341-95.356-.273-7.671-3.409-12.615-11.421-12.615-20.217v-9.478c0-24.819 18.001-45.445 41.354-47.592a213.091 213.091 0 0 1 38.457 0c23.353 2.147 41.354 22.74 41.354 47.592v9.512c0 9.035-5.216 17.217-13.194 20.456Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M180.893 120.65c10.16-31.4 57.139-59.218 101.289-55.605-7.364-12-19.706-20.319-34.093-21.648a213.08 213.08 0 0 0-38.456 0c-23.353 2.148-41.354 22.74-41.354 47.593v9.477c0 8.796 4.944 16.808 12.614 20.217v-.034Z",
    opacity: 0.14,
    style: {
      mixBlendMode: "screen"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M186.859 59.012h39.274V82.74h-39.274z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#00A7AB",
    d: "M193.234 73.945c1.057.511 2.114 1.057 3.171 1.568 3.682-8.728 16.057-8.864 19.944-.102.886-.443 1.739-.887 2.625-1.33-4.773-11.284-20.762-11.387-25.74-.102v-.034Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M231.861 59.012h39.274V82.74h-39.274z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#00A7AB",
    d: "M238.51 73.945c1.057.511 2.113 1.057 3.17 1.568 3.682-8.728 16.058-8.864 19.944-.102.887-.443 1.739-.887 2.625-1.33-4.773-11.284-20.762-11.387-25.739-.102v-.034Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A7AB",
    d: "M220.644 88.707v3.887a8.454 8.454 0 0 0 8.455 8.454 8.453 8.453 0 0 0 8.455-8.454v-3.887h-16.91Z"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#698D94",
    d: "m254.353 34.602-.031.015a3.443 3.443 0 0 0-1.599 4.6l1.084 2.24a3.444 3.444 0 0 0 4.6 1.599l.03-.015a3.443 3.443 0 0 0 1.599-4.6l-1.084-2.24a3.443 3.443 0 0 0-4.599-1.599ZM270.782 7.246l-.029.019a4.364 4.364 0 0 0-1.213 6.05l1.719 2.583a4.364 4.364 0 0 0 6.051 1.213l.029-.018a4.364 4.364 0 0 0 1.213-6.051l-1.72-2.583a4.363 4.363 0 0 0-6.05-1.213ZM257.594 8.283l-.03.016a4.125 4.125 0 0 0-1.672 5.59l1.409 2.61a4.125 4.125 0 0 0 5.589 1.671l.03-.016a4.126 4.126 0 0 0 1.672-5.59l-1.409-2.61a4.125 4.125 0 0 0-5.589-1.671Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M258.453 39.48c-2.318-10.5 4.296-20.9 14.796-23.251 10.501-2.319 20.899 4.295 23.251 14.796 2.353 10.5-2.182 30.308-12.682 32.66-10.501 2.318-23.013-13.705-25.331-24.205h-.034Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#20244D",
    d: "M261.114 45.986c-1.33-.545-2.284-1.125-3.341-1.875-1.023-.716-1.943-1.602-2.796-2.557-1.739-1.91-3-4.364-3.682-6.989v-.136c-.511-1.875.614-3.819 2.489-4.296 1.875-.477 3.818.648 4.296 2.523.068.273.102.58.102.818 0 1.637.375 3.307 1.227 4.875.409.784.921 1.535 1.5 2.25a13.79 13.79 0 0 0 1.944 1.841l.238.205c.852.682 1.023 1.91.341 2.761a1.973 1.973 0 0 1-2.318.614v-.034ZM263.499 23.215c-1.806-3.034-3.75-6.068-5.795-8.898-2.046-2.83-4.262-5.591-6.58-7.739a3.81 3.81 0 0 1-.273-5.352 3.811 3.811 0 0 1 5.353-.273c.136.136.306.307.409.443 2.591 3.205 4.398 6.512 6.136 9.819a128.202 128.202 0 0 1 4.603 10.125c.443 1.091-.102 2.352-1.193 2.796-.989.409-2.114 0-2.625-.887l-.035-.034ZM274.477 20.692a27.094 27.094 0 0 0-1.296-3.614 24.15 24.15 0 0 0-1.875-3.341c-1.398-2.08-3.204-3.682-5.114-4.67-1.977-1.023-2.727-3.444-1.704-5.421 1.022-1.978 3.443-2.728 5.42-1.705.239.136.478.273.682.443l.103.102c2.829 2.319 4.841 5.285 6.136 8.319a30.133 30.133 0 0 1 1.5 4.603c.341 1.568.58 3.068.682 4.807.068 1.227-.886 2.318-2.114 2.386a2.188 2.188 0 0 1-2.284-1.67l-.068-.205-.068-.034Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "M260.022 12.85c-2.012 1.09-5.217-.921-4.126 1.09l1.398 2.592a4.153 4.153 0 0 0 5.625 1.67 4.153 4.153 0 0 0 1.671-5.625l-1.398-2.591c-1.091-2.012-1.159 1.772-3.17 2.864ZM273.796 11.762c-2.012 1.33-5.557-.478-4.228 1.534l1.705 2.591c1.329 2.011 4.057 2.557 6.068 1.227 2.012-1.33 2.557-4.057 1.228-6.068l-1.705-2.591c-1.33-2.012-1.057 1.977-3.068 3.307Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#698D94",
    d: "M290.206 10.335a3.954 3.954 0 1 0-6.118 5.013l1.751 2.136a3.954 3.954 0 1 0 6.118-5.013l-1.751-2.136Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#20244D",
    d: "M287.603 22.772c0-1.023-.068-2.318-.307-3.41-.239-1.124-.614-2.181-1.091-3.033-.477-.887-1.159-1.535-1.841-2.046-.682-.545-1.568-.75-2.421-.989l-.238-.068c-1.841-.511-2.932-2.42-2.421-4.261.512-1.841 2.421-2.932 4.262-2.42.17.033.375.135.545.204 1.603.75 3.205 1.636 4.432 3 1.228 1.33 2.148 2.898 2.659 4.466.512 1.602.716 3.17.75 4.705 0 1.568-.102 2.966-.477 4.534-.238 1.057-1.295 1.704-2.352 1.466-.921-.205-1.534-1.057-1.5-1.978v-.204.034Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "M287.772 13.6c-1.671 1.397-5.046.067-3.648 1.772l1.773 2.148c1.398 1.67 3.852 1.943 5.557.545 1.67-1.398 1.943-3.852.545-5.557l-1.772-2.148c-1.398-1.67-.75 1.875-2.455 3.24ZM256.237 38.487c-1.705.818-4.296-.955-3.478.75l1.057 2.216a3.462 3.462 0 0 0 4.637 1.602 3.462 3.462 0 0 0 1.602-4.636l-1.057-2.216c-.818-1.705-1.023 1.432-2.761 2.25v.034Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F2F2",
    d: "M231.384 234.724c16.814 0 30.444-1.084 30.444-2.421 0-1.336-13.63-2.42-30.444-2.42s-30.445 1.084-30.445 2.42c0 1.337 13.631 2.421 30.445 2.421Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#05140F",
    d: "M287.806 127.91c.409-.647.886-1.636 1.193-2.522.307-.921.545-1.841.648-2.762.238-1.841-.069-3.58-.648-5.182-.682-1.909.307-4.023 2.182-4.705 1.875-.681 4.023.307 4.704 2.182.103.273.171.546.205.818v.137c.307 2.795 0 5.659-.955 8.182-.477 1.261-1.056 2.455-1.772 3.546-.75 1.125-1.466 2.045-2.557 3.068a2.048 2.048 0 0 1-2.898-.068 2.062 2.062 0 0 1-.273-2.489l.171-.273v.068ZM273.727 121.368a40.503 40.503 0 0 1-.75-4.296 36.92 36.92 0 0 1-.239-4.364c.034-2.966.443-6.068 1.807-9.171v-.102c.852-1.841 3.034-2.693 4.875-1.909 1.841.784 2.694 2.966 1.91 4.841a4.465 4.465 0 0 1-.375.682c-1.194 1.636-2.046 3.852-2.523 6.239a31.967 31.967 0 0 0-.512 3.682c-.102 1.227-.136 2.557-.102 3.75v.136c.034 1.125-.852 2.08-1.977 2.148-.989.034-1.841-.648-2.08-1.568l-.034-.068ZM265.442 119.15c-.852-1.5-1.329-2.761-1.841-4.159a30.572 30.572 0 0 1-1.125-4.194c-.579-2.829-.852-5.727-.886-8.625 0-2.08 1.602-3.716 3.614-3.75 2.011 0 3.681 1.602 3.716 3.614 0 .238 0 .477-.069.716-.443 2.42-.716 4.909-.681 7.398 0 1.227.102 2.488.238 3.682.137 1.193.443 2.522.716 3.443l.068.273c.341 1.091-.272 2.216-1.363 2.557a2.017 2.017 0 0 1-2.387-.955ZM254.941 123.139c-1.296-3.682-2.421-7.296-2.591-11.66a3.23 3.23 0 0 1 3.034-3.375 3.169 3.169 0 0 1 3.307 3.034c0 .273 0 .58-.068.853-.682 3-.58 6.784-.239 10.261v.103c.103.988-.613 1.875-1.602 1.943a1.832 1.832 0 0 1-1.875-1.193l.034.034Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "M271.939 113.629a3.477 3.477 0 1 0 6.878 1.025l.367-2.461a3.476 3.476 0 1 0-6.878-1.026l-.367 2.462ZM289.034 123.144a3.478 3.478 0 0 0 6.879 1.026l.367-2.462a3.478 3.478 0 1 0-6.879-1.025l-.367 2.461ZM262.087 112.512a3.477 3.477 0 1 0 6.86-1.145l-.41-2.455a3.478 3.478 0 1 0-6.86 1.146l.41 2.454ZM252.22 117.882a3.478 3.478 0 0 0 6.949-.286l-.102-2.487a3.477 3.477 0 1 0-6.949.287l.102 2.486Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M293.09 131.628c-.443-11.182-9.887-19.876-21.069-19.398-11.182.443-19.876 9.886-19.399 21.069.478 11.182 10.296 29.899 21.478 29.421 11.183-.443 19.467-19.909 18.99-31.092Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M367.037 197.051c.409-3.478-14.387-11.762-33.684-18.751-19.33-7.023-36.001-10.126-37.876-7.16-5.012 7.842-8.796 15.035-10.637 20.149-7.5 20.694 3.75 43.775 25.126 51.514 21.376 7.739 44.797-2.728 52.298-23.422 1.841-5.114 3.579-13.057 4.773-22.296v-.034Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "M366.96 197.324c1.207-3.328-13.842-11.84-33.612-19.012-19.771-7.173-36.777-10.29-37.984-6.962-1.208 3.327 13.841 11.84 33.612 19.012 19.771 7.173 36.777 10.29 37.984 6.962Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#05140F",
    d: "M361.922 237.111c.034.614.17 1.5.34 2.182.205.75.478 1.432.819 2.079.681 1.296 1.67 2.319 2.761 3.137a2.91 2.91 0 0 1 .682 4.091 2.911 2.911 0 0 1-4.091.682 3.427 3.427 0 0 1-.511-.443l-.069-.103c-1.466-1.704-2.557-3.716-3.068-5.829a14.181 14.181 0 0 1-.443-3.137c0-1.057.034-2.011.273-3.171a1.615 1.615 0 0 1 1.943-1.261c.75.136 1.261.784 1.295 1.5v.273h.069Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "M363.534 239.354a2.787 2.787 0 0 0-3.299-2.158 2.788 2.788 0 0 0-2.137 3.312l.404 1.901a2.787 2.787 0 0 0 3.299 2.157 2.787 2.787 0 0 0 2.137-3.312l-.404-1.9Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M356.774 237.079c5.352 7.126 15.512 8.592 22.637 3.205 7.125-5.352 8.591-15.512 3.205-22.637-5.387-7.126-20.285-15.001-27.445-9.614-7.159 5.386-3.784 21.887 1.569 29.046h.034Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#05140F",
    d: "M372.695 239.124c1.295 2.046 2.897 4.091 4.602 5.762 1.705 1.704 3.648 3.102 5.455 3.614a2.932 2.932 0 0 1 2.011 3.613 2.906 2.906 0 0 1-3.614 2.012 1.19 1.19 0 0 1-.477-.205h-.068c-3.068-1.568-5.08-3.818-6.75-6.068-1.671-2.318-2.966-4.671-4.057-7.262-.341-.818 0-1.807.852-2.148a1.705 1.705 0 0 1 2.046.614v.068ZM377.127 234.386c.75 1.364 1.909 2.864 2.932 3.409.511.273.784.205.852.102.068-.068.409-.409.75-.818l.068-.102a2.928 2.928 0 0 1 4.16-.239 2.928 2.928 0 0 1 .238 4.16c-.17.17-.341.341-.545.477-1.091.75-2.318 1.602-4.159 1.67-1.807.069-3.341-.818-4.228-1.704-.954-.921-1.534-1.875-2.011-2.864a18.264 18.264 0 0 1-1.125-2.966 1.686 1.686 0 0 1 1.125-2.046 1.7 1.7 0 0 1 1.909.785l.068.102-.034.034ZM378.695 226.273a11.098 11.098 0 0 0 1.875 1.67 8.344 8.344 0 0 0 2.114 1.091c.716.239 1.363.239 2.011.17.614-.068 1.193-.375 1.773-.681l.17-.069a2.534 2.534 0 0 1 3.41 1.057 2.534 2.534 0 0 1-1.057 3.41c-.137.068-.273.136-.375.17-1.228.409-2.523.716-3.853.614-1.329-.103-2.591-.478-3.648-1.057a11.439 11.439 0 0 1-2.727-2.114 14.293 14.293 0 0 1-2.011-2.659c-.41-.682-.171-1.534.511-1.943a1.441 1.441 0 0 1 1.773.272l.102.103-.068-.034Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "M377.439 243.835a2.788 2.788 0 0 0-3.901-.566 2.787 2.787 0 0 0-.543 3.904l1.167 1.554a2.788 2.788 0 0 0 3.901.566 2.787 2.787 0 0 0 .543-3.904l-1.167-1.554ZM378.974 235.385a2.786 2.786 0 0 0-3.933-.258 2.786 2.786 0 0 0-.234 3.934l1.285 1.457a2.787 2.787 0 0 0 3.933.259 2.787 2.787 0 0 0 .234-3.935l-1.285-1.457ZM381.786 227.299a2.788 2.788 0 0 0-3.899.581 2.788 2.788 0 0 0 .605 3.895l1.564 1.152a2.788 2.788 0 0 0 3.899-.581 2.786 2.786 0 0 0-.604-3.894l-1.565-1.153Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "m322.82 64.467 20.217-52.025c.306-.75 1.125-1.125 1.806-.784l17.183 8.591c1.807.92 3.205 2.591 3.852 4.637 1.16 3.716 2.08 6.58 3.376 10.807.102.375.102.784-.069 1.16-.784 1.738-4.602 9.443-4.602 9.443l-7.705-4.16L339.9 73.639c-5.932 11.046-9.478 23.49-9.171 36.036a22.439 22.439 0 0 1-2.284 10.33c-4.671 9.511-15.512 13.943-24.512 10.023-10.024-4.398-14.217-17.012-9.376-27.683 1.534-3.375 3.819-6.171 6.478-8.182 9.75-7.364 17.08-17.933 21.785-29.66v-.035Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M306.763 130.606c-10.023-4.398-14.217-17.012-9.375-27.683 1.534-3.375 3.818-6.17 6.477-8.182 9.751-7.364 17.08-17.932 21.785-29.66l20.694-52.673-1.534-.784c-.682-.34-1.5 0-1.807.784l-20.217 52.025c-4.738 11.728-12.034 22.296-21.785 29.66-2.693 2.012-4.943 4.807-6.477 8.183-4.841 10.671-.648 23.285 9.375 27.683 1.432.647 2.932 1.022 4.466 1.261a15.238 15.238 0 0 1-1.602-.614Z",
    opacity: 0.3
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#101125",
    d: "m364.549 46.295-4.807-10.193-3.375 6.852 8.182 3.341Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M327.5 114.052c1.797-7.971-2.686-15.773-10.015-17.426-7.328-1.653-14.727 3.469-16.525 11.44-1.797 7.972 2.686 15.774 10.015 17.427 7.328 1.653 14.727-3.469 16.525-11.441Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "M325.633 113.939c1.334-5.914-1.992-11.703-7.429-12.929-5.437-1.226-10.925 2.574-12.259 8.488-1.334 5.915 1.992 11.703 7.428 12.929 5.437 1.227 10.926-2.574 12.26-8.488Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M416.302 124.505c-2.25-26.115-20.251-46.4-46.298-56.73-26.046-10.296-52.57-7.262-72.548 9.682-5.83 4.944-4.296 12.205-11.148 29.524-6.853 17.319-12.615 20.763-10.126 29.627 5.557 19.569 24.615 34.092 49.23 43.842 24.648 9.751 48.513 12.239 65.9 1.739 16.978-11.762 25.228-42.581 24.956-57.684h.034Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#05140F",
    d: "M350.06 171.245c-23.626 2.08-49.74-7.704-64.912-25.705-4.091-4.841-4.875-12.717-2.011-19.944l13.398-33.854c1.5-3.784 4.841-6.307 8.08-6.034 27.001 2.148 51.071 11.66 72.208 28.569 2.523 2.011 3.239 6.137 1.739 9.921l-13.399 33.888c-2.829 7.193-8.796 12.614-15.069 13.159h-.034Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M282.523 140.831c-2.114-5.932-.954-11.352.443-14.864 5.114-12.921 8.455-21.342 13.569-34.263 1.534-3.886 5.046-6.239 8.046-6 21.035 1.5 46.911 8.387 72.207 28.57 2.319 1.84 3.137 6.375 1.773 9.886-18.069-8.625-65.116-20.182-96.004 16.671h-.034Z",
    opacity: 0.2,
    style: {
      mixBlendMode: "screen"
    }
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "m409.994 96.545 22.16-51.207c.341-.75 1.194-1.09 1.841-.716l16.842 9.24c1.773.988 3.102 2.692 3.648 4.772 1.023 3.784 1.807 6.682 2.966 10.944.102.375.068.784-.102 1.125-.853 1.739-4.978 9.273-4.978 9.273l-7.534-4.466-18.137 30.819c-6.342 10.808-10.364 23.115-10.569 35.661a22.346 22.346 0 0 1-2.693 10.228c-5.046 9.341-16.024 13.364-24.888 9.068-9.852-4.773-13.568-17.557-8.318-28.024 1.67-3.341 4.057-6 6.784-7.943 10.023-6.989 17.728-17.251 22.91-28.808l.068.034Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M391.414 162.039c-9.853-4.773-13.569-17.557-8.319-28.024 1.671-3.341 4.057-6 6.785-7.943 10.023-6.989 17.728-17.251 22.91-28.808l22.705-51.855-1.5-.818c-.681-.375-1.5-.034-1.841.716l-22.16 51.206c-5.182 11.524-12.887 21.82-22.91 28.809-2.761 1.909-5.114 4.602-6.784 7.943-5.25 10.466-1.534 23.251 8.318 28.024a17.374 17.374 0 0 0 4.398 1.398 21.613 21.613 0 0 1-1.568-.648h-.034Z",
    opacity: 0.3
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#101125",
    d: "m452.404 79.981-4.432-10.364-4.023 7.432 8.455 2.932Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M412.725 146.262c2.1-7.897-2.084-15.864-9.344-17.795-7.26-1.93-14.848 2.907-16.948 10.804-2.1 7.897 2.084 15.864 9.344 17.795 7.26 1.93 14.848-2.907 16.948-10.804Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "M410.927 146.12c1.558-5.859-1.545-11.77-6.931-13.202-5.386-1.432-11.016 2.157-12.574 8.016-1.557 5.859 1.546 11.77 6.932 13.202 5.386 1.432 11.015-2.157 12.573-8.016Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A7AB",
    d: "M297.49 109.028c.58.784 1.159 1.569 1.739 2.319 5.966-5.046 15.103-.512 14.694 7.33h2.42c.682-10.058-11.012-16.092-18.853-9.683v.034Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A7AB",
    d: "M333.559 127.608c.614.853 1.262 1.705 1.876 2.523 6.477-5.489 16.432-.579 15.989 7.978h2.625c.75-10.944-11.966-17.489-20.524-10.535l.034.034Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#v)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A7AB",
    d: "m307.003 132.723-1.569 3.102c-1.875 3.716-.409 8.285 3.307 10.16 3.716 1.875 8.285.409 10.16-3.307l1.568-3.103-13.5-6.852h.034Z"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEEFF1",
    d: "M320.502 264.896c17.247 0 31.229-1.252 31.229-2.796 0-1.544-13.982-2.795-31.229-2.795s-31.229 1.251-31.229 2.795 13.982 2.796 31.229 2.796Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#05140F",
    d: "M145.301 56.76a17.866 17.866 0 0 1-3.136-2.455 18.115 18.115 0 0 1-2.489-3.069c-1.466-2.25-2.387-4.977-2.694-7.772v-.137c-.238-2.011 1.228-3.818 3.273-4.023a3.671 3.671 0 0 1 4.023 3.273v.887c-.238 1.704-.136 3.477.478 5.216.306.886.681 1.738 1.193 2.556a14.596 14.596 0 0 0 1.704 2.217l.239.238a2.02 2.02 0 0 1-.102 2.898c-.682.648-1.705.716-2.489.239v-.069ZM155.905 44.177a29.92 29.92 0 0 0-.887-3.648 39.162 39.162 0 0 0-1.295-3.512c-.989-2.216-2.285-4.227-3.785-5.557-1.5-1.363-1.636-3.682-.272-5.182 1.363-1.5 3.682-1.636 5.182-.272.204.17.375.375.511.545l.068.102c1.978 2.762 3.069 5.728 3.716 8.592.307 1.431.546 2.897.682 4.33.137 1.465.205 2.829.171 4.363 0 1.125-.955 2.046-2.114 2.011-.989 0-1.807-.75-1.977-1.704v-.136.068ZM163.676 38.997c.103-.955.068-2.318 0-3.512-.102-1.227-.307-2.454-.545-3.648-.512-2.42-1.296-4.806-2.25-7.09-.784-1.876.068-4.024 1.943-4.808 1.875-.784 4.023.069 4.807 1.944.102.204.17.443.205.681v.069c.579 2.83.92 5.727.954 8.625a37.32 37.32 0 0 1-.239 4.364c-.17 1.5-.409 2.795-.92 4.466-.341 1.09-1.5 1.67-2.557 1.364-.955-.307-1.534-1.194-1.432-2.148v-.273l.034-.034ZM175.199 41.622c-.409-3.443-1.091-7.16-2.386-9.955-.75-1.602-.034-3.477 1.534-4.227 1.568-.75 3.477-.035 4.227 1.534.103.273.205.511.239.784v.068c.75 4.296.409 8.046-.068 11.932a1.827 1.827 0 0 1-2.012 1.569 1.809 1.809 0 0 1-1.568-1.569v-.102l.034-.034Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "M159.303 33.728a3.477 3.477 0 1 0-6.505 2.459l.879 2.328a3.478 3.478 0 0 0 6.506-2.459l-.88-2.328ZM144.591 46.615a3.478 3.478 0 0 0-6.506 2.458l.879 2.328a3.478 3.478 0 0 0 6.506-2.458l-.879-2.328ZM169.447 30.414a3.477 3.477 0 1 0-6.947.333l.119 2.486a3.478 3.478 0 0 0 6.947-.333l-.119-2.486ZM179.961 33.61a3.477 3.477 0 1 0-6.852 1.191l.426 2.452a3.478 3.478 0 0 0 6.852-1.19l-.426-2.453Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M143.289 58.09c-1.909-11.012 5.455-21.512 16.501-23.422 11.012-1.909 21.512 5.455 23.422 16.501 1.909 11.012-3.751 31.4-14.762 33.308-11.012 1.91-23.217-15.341-25.161-26.353v-.034Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M97.81 191.254c.444-3.478 16.808-7.944 37.195-10.092 20.456-2.147 37.365-1.193 38.49 2.148 2.966 8.83 4.91 16.706 5.489 22.126 2.319 21.888-14.148 41.559-36.785 43.945-22.638 2.387-42.82-13.432-45.139-35.319-.58-5.421-.34-13.535.75-22.808Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "M136.358 193.922c20.916-2.205 37.57-6.847 37.199-10.368-.371-3.52-17.628-4.586-38.543-2.38-20.916 2.206-37.57 6.848-37.2 10.368.372 3.52 17.628 4.586 38.544 2.38Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#05140F",
    d: "M96.412 231.725c-.068 1.193-.204 2.114-.477 3.136a14.156 14.156 0 0 1-1.16 2.932c-.988 1.91-2.522 3.614-4.363 4.91l-.102.068a2.948 2.948 0 0 1-4.091-.716 2.948 2.948 0 0 1 .716-4.091c.204-.136.409-.239.613-.341 1.262-.511 2.455-1.261 3.444-2.352.477-.546.92-1.16 1.295-1.841.375-.648.682-1.466.886-2.046l.069-.239a1.633 1.633 0 0 1 2.045-1.056c.716.238 1.16.92 1.16 1.636h-.035Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "M90.126 234.964a2.788 2.788 0 0 0 1.279 3.729c1.38.67 3.046.087 3.72-1.302l.85-1.748a2.787 2.787 0 0 0-1.28-3.728 2.787 2.787 0 0 0-3.72 1.301l-.849 1.748Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M98.15 232.611c-6.921 5.625-17.115 4.602-22.74-2.318-5.625-6.921-4.602-17.115 2.318-22.74 6.921-5.625 23.32-9.648 28.945-2.727 5.625 6.92-1.603 22.16-8.523 27.819v-.034Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#05140F",
    d: "M84.685 232.85a38.383 38.383 0 0 1-5.693 6.068c-2.182 1.807-4.67 3.512-8.012 4.262h-.068a2.875 2.875 0 0 1-3.478-2.182c-.34-1.568.648-3.137 2.216-3.477.17-.035.375-.069.546-.069 1.875-.068 4.091-.954 6.136-2.182 2.046-1.227 4.092-2.829 5.864-4.5l.069-.068c.647-.614 1.704-.614 2.318.068.58.58.614 1.5.136 2.114l-.034-.034ZM81.753 226.917a17.061 17.061 0 0 1-1.807 2.625c-.716.819-1.5 1.603-2.66 2.285-1.09.647-2.795 1.159-4.534.647-1.773-.511-2.727-1.636-3.648-2.625-1.09-1.193-.988-3.068.239-4.159 1.193-1.091 3.068-.989 4.16.239.17.17.306.375.408.579l.069.137c.238.443.477.886.51.954.035.137.308.273.853.137 1.125-.273 2.591-1.466 3.648-2.592l.102-.102a1.628 1.628 0 0 1 2.319-.102c.58.545.681 1.364.306 2.045l.035-.068ZM81.446 218.907a13.78 13.78 0 0 1-2.591 2.113c-.955.58-2.012 1.091-3.17 1.398a8.796 8.796 0 0 1-3.785.137c-1.33-.205-2.523-.819-3.614-1.501a2.545 2.545 0 0 1-.818-3.477 2.545 2.545 0 0 1 3.477-.818c.103.068.239.136.307.238l.136.137c.478.443.955.886 1.569 1.091.58.238 1.227.375 1.977.341.75-.034 1.534-.239 2.284-.546a13.59 13.59 0 0 0 2.216-1.159l.103-.068a1.425 1.425 0 0 1 1.977.375c.409.58.307 1.33-.136 1.807l.068-.068Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "M74.99 235.438a2.787 2.787 0 0 0-.413 3.92 2.788 2.788 0 0 0 3.922.388l1.507-1.227a2.787 2.787 0 0 0 .412-3.92 2.787 2.787 0 0 0-3.922-.389l-1.507 1.228ZM75.426 226.73a2.787 2.787 0 0 0-.72 3.875 2.787 2.787 0 0 0 3.88.696l1.599-1.105a2.788 2.788 0 0 0 .72-3.876 2.787 2.787 0 0 0-3.88-.695l-1.599 1.105ZM74.416 217.773a2.787 2.787 0 0 0-1.523 3.635 2.786 2.786 0 0 0 3.644 1.501l1.796-.741a2.788 2.788 0 0 0 1.523-3.636 2.788 2.788 0 0 0-3.644-1.501l-1.796.742Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "m131.086 60.579-29.933-47.082c-.443-.681-1.33-.886-1.943-.409L84.039 24.85c-1.603 1.227-2.625 3.137-2.864 5.284-.409 3.887-.75 6.853-1.227 11.25-.034.376.068.785.307 1.126 1.125 1.568 6.34 8.353 6.34 8.353l6.751-5.592 22.774 27.581c7.977 9.682 13.841 21.206 16.023 33.581.58 3.409 2.012 6.716 4.262 9.682 6.443 8.421 17.932 10.671 26.012 5.046 9.001-6.273 10.637-19.467 3.819-28.978-2.182-3.035-4.944-5.285-7.978-6.75-10.978-5.32-20.217-14.251-27.138-24.854h-.034Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M159.724 122.354c9.001-6.273 10.637-19.466 3.819-28.978-2.182-3.034-4.944-5.285-7.978-6.75-10.978-5.319-20.217-14.251-27.137-24.854L97.881 14.145l1.364-1.057c.613-.477 1.5-.272 1.943.41l29.933 47.08c6.921 10.57 16.16 19.536 27.137 24.854 3.035 1.466 5.796 3.75 7.978 6.75 6.819 9.512 5.182 22.706-3.818 28.979-1.296.921-2.694 1.568-4.125 2.08.477-.273.988-.58 1.466-.887h-.035Z",
    opacity: 0.3
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#101125",
    d: "m86.596 50.863 2.761-10.91 4.637 6.069-7.398 4.84Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M154.616 118.117c6.867-3.047 9.747-11.573 6.432-19.042-3.314-7.47-11.568-11.054-18.435-8.007-6.867 3.048-9.746 11.573-6.432 19.042 3.315 7.469 11.569 11.054 18.435 8.007Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "M151.635 115.608c5.095-2.261 7.231-8.586 4.771-14.128-2.459-5.541-8.582-8.201-13.676-5.94-5.094 2.26-7.231 8.585-4.771 14.127 2.459 5.542 8.582 8.201 13.676 5.941Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M51.07 137.659c-2.897-26.047 10.842-49.468 34.366-64.64 23.524-15.17 50.15-17.352 73.06-4.602 6.682 3.716 6.58 11.148 16.705 26.797 10.091 15.648 16.433 17.932 15.683 27.103-1.637 20.285-17.524 38.218-39.786 52.605-22.263 14.353-45.207 21.444-64.333 14.523-18.92-8.25-33.035-36.854-35.728-51.752l.034-.034Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M125.119 170.628c23.558-2.557 47.32-17.25 58.673-37.842 3.069-5.557 2.319-13.433-1.909-19.944l-19.705-30.581c-2.216-3.41-5.966-5.25-9.103-4.364-26.047 7.364-47.832 21.376-65.253 42.07-2.08 2.489-1.977 6.648.239 10.091l19.739 30.615c4.194 6.512 11.08 10.671 17.319 9.989v-.034Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M185.463 127.673c.92-6.239-1.296-11.318-3.342-14.489-7.534-11.659-12.443-19.296-19.978-30.956-2.284-3.511-6.17-5.114-9.068-4.33-20.353 5.558-44.389 17.353-65.253 42.071-1.91 2.25-1.841 6.886.204 10.057 16.058-11.967 59.969-32.456 97.437-2.319v-.034Z",
    opacity: 0.2,
    style: {
      mixBlendMode: "screen"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M51.82 109.022 20.114 63.1c-.477-.682-1.363-.818-1.943-.34L3.443 75.1C1.875 76.397.92 78.34.784 80.488.511 84.374.307 87.374 0 91.772c0 .375.102.784.34 1.09 1.194 1.535 6.683 8.115 6.683 8.115l6.512-5.83L37.33 121.84c8.319 9.376 14.66 20.66 17.285 32.933a21.942 21.942 0 0 0 4.636 9.512c6.75 8.182 18.342 9.989 26.184 4.057 8.727-6.614 9.886-19.876 2.693-29.115-2.284-2.932-5.148-5.114-8.217-6.443-11.182-4.909-20.762-13.467-28.058-23.797l-.034.034Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M82.776 169.673c8.728-6.614 9.887-19.876 2.694-29.115-2.284-2.932-5.148-5.114-8.216-6.444-11.183-4.909-20.763-13.466-28.059-23.796L16.843 63.884l1.33-1.125c.579-.477 1.465-.34 1.943.341l31.706 45.922c7.33 10.33 16.875 18.888 28.058 23.797a21.464 21.464 0 0 1 8.216 6.443c7.193 9.239 6.034 22.501-2.693 29.115-1.262.955-2.626 1.671-4.057 2.25a19.84 19.84 0 0 0 1.397-.954h.034Z",
    opacity: 0.3
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#101125",
    d: "M7.023 101.012 9.342 90l5.386 6.512-7.705 4.5Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M77.533 165.648c6.746-3.306 9.3-11.935 5.703-19.272-3.596-7.338-11.98-10.606-18.726-7.3-6.746 3.306-9.3 11.935-5.703 19.273 3.596 7.337 11.98 10.606 18.726 7.299Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BBBC5",
    d: "M74.433 163.243c5.005-2.453 6.898-8.855 4.23-14.299-2.668-5.444-8.888-7.869-13.892-5.416-5.005 2.452-6.899 8.854-4.23 14.298 2.668 5.444 8.888 7.869 13.892 5.417Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#E)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A7AB",
    d: "M164.596 99.374a93.054 93.054 0 0 1-1.261 2.625c-6.818-3.784-14.898 2.42-12.989 10.057-.784.17-1.603.307-2.387.477-2.625-9.716 7.671-17.932 16.603-13.16h.034Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#F)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A7AB",
    d: "M132.824 124.601c-.444.955-.921 1.91-1.364 2.864-7.432-4.125-16.228 2.625-14.114 10.944-.853.17-1.739.341-2.591.511-2.864-10.568 8.318-19.501 18.069-14.319Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#G)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A7AB",
    d: "m159.892 124.464 2.148 2.761c2.591 3.273 2.012 8.046-1.295 10.603-3.273 2.591-8.046 2.011-10.603-1.296l-2.148-2.761 11.898-9.341v.034Z"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEEFF1",
    d: "M169.201 262.202c0 1.534-13.978 2.795-31.228 2.795-17.251 0-31.229-1.261-31.229-2.795s13.978-2.796 31.229-2.796c17.25 0 31.228 1.262 31.228 2.796Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-159.94 96.62 79.65) scale(30.7172)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F2F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E2EEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#CBE0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#AECFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(229.848 176.289) scale(55.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F2F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E2EEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#CBE0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#AECFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(227.396 81.001) scale(91.538)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FDFDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#F6F9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#EAF2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D9E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#C3DCE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#A9CCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(36.99 93.885 423.834) scale(40.3654)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F3F8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D5E6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#A4CAD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-170.59 141.43 62.057) scale(37.7062)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F2F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E2EEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#CBE0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#AECFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(19.94 -392.966 1041.463) scale(59.7298)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F2F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E2EEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#CBE0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#AECFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.42 298.768 -63.989) scale(53.4568)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F3F8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D5E6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#A4CAD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(12.71 -350.462 1488.487) scale(31.0241)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FDFDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F6F9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#EAF2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D9E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#C3DCE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A9CCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(21.59 -96.295 975.394) scale(102.959)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FAFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EEF5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9E8EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BCD7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#96C2CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(14.89 -354.506 1619.125) scale(31.0241)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FDFDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F6F9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#EAF2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D9E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#C3DCE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A9CCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-21.63 266.278 -405.722) scale(37.7062)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F2F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E2EEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#CBE0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#AECFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(173.98 61.098 101.672) scale(59.7298)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F2F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E2EEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#CBE0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#AECFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-79.66 198.375 52.304) scale(53.4568)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F3F8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D5E6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#A4CAD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "A",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(156.07 60.799 69.288) scale(31.0241)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FDFDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F6F9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#EAF2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D9E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#C3DCE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A9CCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "B",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.19 39.742 68.55) scale(102.959)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FAFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EEF5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D9E8EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BCD7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#96C2CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(153.89 15.451 85.707) scale(31.0241)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FDFDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F6F9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#EAF2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D9E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#C3DCE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A9CCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 149.426,
    x2: 171.313,
    y1: 97.401,
    y2: 97.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDFDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F6F9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#EAF2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#D9E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C3DCE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A9CCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 153.652,
    x2: 152.97,
    y1: 67.16,
    y2: 97.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20244D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#1E2248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1E3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 309.013,
    x2: 287.125,
    y1: 97.401,
    y2: 97.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDFDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F6F9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#EAF2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#D9E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C3DCE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A9CCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#8BBBC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 304.785,
    x2: 305.467,
    y1: 67.16,
    y2: 97.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20244D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#1E2248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1E3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 340.951,
    x2: 313.143,
    y1: 48.996,
    y2: 115.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00877D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#004F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003922"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 441.742,
    x2: 383.681,
    y1: 58.225,
    y2: 166.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00877D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#004F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003922"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 125.765,
    x2: 126.237,
    y1: 24.445,
    y2: 125.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#303031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2B2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1F1F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 44.259,
    x2: 48.567,
    y1: 71.909,
    y2: 172.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#303031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2B2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1F1F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    width: 30.683,
    height: 26.113,
    x: 213.758,
    y: 81.82,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.443
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.654902 0 0 0 0 0.670588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4168_8163"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4168_8163",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "t",
    width: 22.291,
    height: 15.733,
    x: 295.786,
    y: 104.647,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.852
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.654902 0 0 0 0 0.670588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4168_8163"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4168_8163",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "u",
    width: 24.237,
    height: 17.084,
    x: 331.684,
    y: 122.866,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.92
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.654902 0 0 0 0 0.670588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4168_8163"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4168_8163",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "v",
    width: 28.123,
    height: 26.351,
    x: 298.483,
    y: 126.586,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.068
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.654902 0 0 0 0 0.670588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4168_8163"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4168_8163",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "E",
    width: 20.463,
    height: 17.968,
    x: 145.838,
    y: 96.272,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.852
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.654902 0 0 0 0 0.670588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4168_8163"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4168_8163",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "F",
    width: 22.207,
    height: 19.518,
    x: 112.458,
    y: 121.245,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.92
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.654902 0 0 0 0 0.670588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4168_8163"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4168_8163",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "G",
    width: 27.939,
    height: 27.293,
    x: 141.858,
    y: 118.293,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.068
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.654902 0 0 0 0 0.670588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4168_8163"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4168_8163",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "h",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#H",
    transform: "scale(.02174 .03571)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "i",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#I",
    transform: "scale(.02128 .03571)"
  })), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAcCAYAAAAeC42RAAAACXBIWXMAAC4jAAAuIwF4pT92AAADkUlEQVRYhe2Y/U4aQRTFD8siCFitVNua9rWa9AlJeK1qa22rIB8Cwm4z4Vz3cJlVpP7TxElu2MyuM7/7dWbaCnYZ3Z7+XcX96sj5nD/Mff2S77SnG9uDF7AVZ0lkLneWReb+yYmnwVfAZolY1VkiThhssKWzTGzlxA4OPA6+gjagAJcCqIntyXPKbww8QC4A3NPm8nzPd4Ujz4SPgxdRNmCDbADYd78NvtsjfEKYBWGDTWl37tecWT6U05YObIIX0BbhOmFbANoADmjhuSmOlIEb8ATACMCQFp7HfDeTDGwFvw6+Dm0RDsBvABwBOAbwFsAh4VsErwu4lYqBzwgXIAPwAMANgGsAfQC3fGcZ2Aq+EoG2Om4SLoC+o50A6BC8LdA1ibY2p9W4wY8IG6B/0f7QkSGzYvX/KHylJNJNwgXIUwAfaCd0pM1spBE5tKHSZ05MCXhD6J8ALgFc0YEB4Z+MfCoOeOgQ4Y8AzmjvWSptRrgiMrcQiYNb08zKqeF6oyZqpKOAj0Z8Fe2qlMchIxtgPwH4zGh3WNNVid5ElOJeNjJFqonyWFkl/G7CyIeIXwA4B/CDmRhI2SxjUU9dtFtswlMBP2P0W/x2xnT3XXPNHHhVFKnNBn/DZ8usllcm2VusZbHb2zhlU9HqOhc9dnVtkU4YXatPq8s+m2720FRFkxugqVKH6x9xvsHnzDWxl8hlWcRNr61UjkU99vnNhGoQUvudv5bWsatJL6kHBByIkx3O1+lYh+8GzOJISjDztZ6609FqcV9UY8mNrB6/sSYv6cjQbWAjkYD0BfrOwTS5vzVtSw60WNOuqQpcveVc3KRpwuieE9ya6HatiQr50ytD6ppYM5MxE9bwkECuy2wQEanzVECXXPSOUbyWxYas6QtCXzGKqrkabQ2Gv1jl8i6jM3vM6rikPKKqotATAtU5d8P3QzZiODB+i1zN1qC9bK2k1t/D9bBaELbO50HkEIqunUZOtSrnRlww40J2x9iMdNnRvJrP0e3lLtLm0Jzl1nDabn2ziDWmBzd9zvg8kIzM5HY3Eana7h4dvun2dB8rkzn3rMk+YymZRdnJmUqTzKVspnIUw9305s+C3oS/54ztOXL7zOQeX5rRhJOZa07T09jp+HzoYuRy2Ey55q3bZz2jJcNfa+GkLLbpTv9GjOzjb5W+ibe41pYvrrq+Gi/03wuRPYp9XmqP1/E6/tcB4C/ruu0L1lZ93QAAAABJRU5ErkJggg==",
    id: "H",
    width: 46,
    height: 28
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAcCAYAAADxyeavAAAACXBIWXMAAC4jAAAuIwF4pT92AAADpUlEQVRYhe1Y7U7bQBCcONh8hBAgLfTztSrxhJHyWqWIFgiEFtshcVydPIvHZzsJ0D+VOGl1duLszezO7p3TwUvHaKy/bbt2I/dm4Oxb/uJ1Vyy0epSAO2vMB7/k7NuriGwOvgDuLADQ5exfm5lfA57JbNfLCqkXkFgPvg56C0BIi3hv1hUyFmUHdg5gAeCR13P5rCTzTAKrwRfALZoGdgfArtg2LRQS5ncpoGcAUgCJNxuh7CkTG5JoBl+PtoHuAegDOOC8D2CP30UkYJEHAS0E+APtN+0P7xMhsXEW6uBL4CaRbQJ0YA8BHNOOSKIn4E065jeTyCcCfArgDsAtZyOSipzWEqiCrwIPKQ0X3QGAIYB3AE44H5PQHoFr4dpYiuaNgAM5JfBr2oT3jkTMTK0lsNVAxoBbtB3I9wBOAXwg+CEJGXDtLm2WieQGNJPergRAA7rAaNxKoARfFucWnfUZYQf6E+2Unx3wmS6BLqSDaCtEQ6dyYK1+eiK7ULKW11ppq2xKuYR0NCBIB/gLgK8APjLifdYBCDZhqrV7ZLKgZXKbvg1oh/K4B3AF4ALAdwA/APyijOInfw3RV9lY1HcIcEiZOPCfKZ0+wWR0bMU3pZZNrxb9TkPRm1x6kj3tTlYfj5V9YDSu7cYGvkkyQ+r7RKTSpdN7FpkrthsptgdZNPfA99itrPCH9BmRUEbiMf3E0n1sZ/YiX55XAlnIOsyhFGZAYLdM6yXtWtqdL5uO7BM9+nLEE+npAz5j5I68FprKs62R104TiUZD/ijlwj8BnFObl4y8ASpbXFWOVkt+K7Ri3OezETOvG5/fgRo1rydFSBdJRS43BH0uhXVX680lKA2KkVNZgc8fE8vcy1hQweVUIrpX8LmcRWbU3ZRRs93viqAvmIEJv/OB+yOQ4lNJGfiUkZ6LP18qDd3GMRmNFXhKBxMCn5Fkws8uSeJWSC1aD1VFTWVev+54R4iYcsmkg8VSP4UMW7qNRcD69pRpW8j1jNfWXR4k4o19uLKg2ymL4QAp+AV97ZBc4hVra0YNfO6B73jpDPhd3HCI2uwcXmTYsmsjF/ChkLN2maJaH5VRVnGRXtvCI++cHjB9ei6fPzl+zktE9RgSee8CkFPoo8imMbOBd2/Rt7P3PSUykVTGlV7+3Ne34nm/MehOXT9ZtoxV5/lAZhvVA9Nr/gWor6NrlLZijVVvUm3fv/qtv2EdePvLP/t7pFikutDbeBv/5QDwF4ii2nDP+d8lAAAAAElFTkSuQmCC",
    id: "I",
    width: 47,
    height: 28
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotsDialog);
export default __webpack_public_path__ + "static/media/BotsDialog.bc74cc11ffcaaba2b7b95d0cae492f35.svg";
export { ForwardRef as ReactComponent };